<nz-input-wrapper style="margin-bottom: 12px">
    <input
        nz-input
        [(ngModel)]="searchValue"
        placeholder="Search by file name or status..."
        (keydown.enter)="onSearch()" />
    <span nzInputSuffix>
        @if (searchValue) {
            <i
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                style="cursor: pointer; color: #bbb"
                (click)="clearSearch()"></i>
        }
    </span>
</nz-input-wrapper>

<nz-table
    #jobsTable
    nzSize="small"
    [nzData]="jobList.Jobs"
    nzShowSizeChanger
    nzTableLayout="fixed"
    nzBordered="true"
    [nzFrontPagination]="false"
    [nzLoading]="loading"
    [nzTotal]="total"
    [nzShowTotal]="totalTemplate"
    [nzPageSize]="pageSize"
    [nzPageSizeOptions]="pageSizeOptions"
    [nzPageIndex]="pageIndex"
    (nzQueryParams)="onQueryParamsChange($event)">
    <thead>
        <tr>
            <th
                nzColumnKey="JobID"
                nzWidth="70px"
                [nzSortFn]="columns[0].compare"
                [nzShowSort]="true"
                [nzSortOrder]="getSortOrder('JobID')">
                ID
            </th>
            <th
                nzColumnKey="JobType"
                nzWidth="180px"
                [nzSortFn]="columns[1].compare"
                [nzShowSort]="true"
                [nzSortOrder]="getSortOrder('JobType')"
                [nzFilters]="jobTypeFilters"
                [nzFilterFn]="true">
                Job Type
            </th>
            <th>File Name</th>
            <th
                nzColumnKey="JobCreateTime"
                nzWidth="140px"
                [nzSortFn]="columns[3].compare"
                [nzShowSort]="true"
                [nzSortOrder]="getSortOrder('JobCreateTime')">
                Time Requested
            </th>
            <th
                nzColumnKey="JobEndTime"
                nzWidth="140px"
                [nzSortFn]="columns[4].compare"
                [nzShowSort]="true"
                [nzSortOrder]="getSortOrder('JobEndTime')">
                Time Finished
            </th>
            <th
                nzColumnKey="JobStatus"
                nzWidth="110px"
                [nzSortFn]="columns[5].compare"
                [nzShowSort]="true"
                [nzSortOrder]="getSortOrder('JobStatus')"
                [nzFilters]="statusFilters"
                [nzFilterFn]="true">
                Status
            </th>
            <th nzWidth="108px" nzAlign="center">Action</th>
        </tr>
    </thead>
    <tbody>
        @for (job of jobList.Jobs; track job.JobID) {
            <tr>
                <td style="font-size: 13px">{{ job.JobID }}</td>
                <td>
                    {{ job.JobType === 4 ? "Process to PerForma" : "Load from Scanner" }}
                </td>
                <td style="word-break: break-all">
                    {{ job.FileName }}
                </td>
                <td style="font-size: 13px">
                    {{ job.JobCreateTime | date: "M/d/yy h:mm a" }}
                </td>
                <td style="font-size: 13px">
                    @if (job.JobEndTime) {
                        <span>{{ job.JobEndTime | date: "M/d/yy h:mm a" }}</span>
                    }
                    @if (!job.JobEndTime) {
                        <span>Processing...</span>
                    }
                </td>
                <td>
                    @if (job.JobStatus === "Complete") {
                        <nz-tag
                            nzColor="#e8f5e9"
                            style="color: #2e7d32; border: 1px solid #c8e6c9; border-radius: 10px">
                            <i class="fa-solid fa-circle-check"></i> Complete
                        </nz-tag>
                    }
                    @if (job.JobStatus === "Queued") {
                        <nz-tag
                            nzColor="#e3f2fd"
                            style="color: #1565c0; border: 1px solid #bbdefb; border-radius: 10px">
                            <i class="fa-solid fa-clock"></i> Queued
                        </nz-tag>
                    }
                    @if (job.JobStatus === "Failed") {
                        <nz-tag
                            nzColor="#fce4ec"
                            style="color: #c62828; border: 1px solid #f8bbd0; border-radius: 10px">
                            <i class="fa-solid fa-circle-xmark"></i> Failed
                        </nz-tag>
                    }
                </td>
                <td style="text-align: center">
                    <nz-space-compact nzSize="small">
                        @if (job.JobParams) {
                            <button
                                nz-button
                                nzType="default"
                                [nz-tooltip]="'Job Information'"
                                (click)="showJobInfo(modalJobInfo, job)">
                                <span nz-icon nzType="info-circle" style="color: #5f94d7"></span>
                            </button>
                        }
                        @if (job.JobStatus === "Queued" || job.JobStatus === "Failed") {
                            <button
                                nz-button
                                nzType="default"
                                [nzLoading]="downloadingJobs.has(job.JobID)"
                                [nz-tooltip]="'Download original scanned file'"
                                (click)="downloadFile(job)">
                                @if (!downloadingJobs.has(job.JobID)) {
                                    <span nz-icon nzType="download"></span>
                                }
                            </button>
                        }
                    </nz-space-compact>
                </td>
            </tr>
        }
    </tbody>
</nz-table>

<ng-template #totalTemplate let-total>
    Showing items {{ pageIndex * pageSize - pageSize + 1 }}-{{
        pageIndex * pageSize > total ? total : pageIndex * pageSize
    }}
    out of {{ total }}
</ng-template>

<ng-template #modalJobInfo>
    <nz-descriptions nzBordered nzSize="small" [nzColumn]="2">
        @if (currentJob?.FileName) {
            <nz-descriptions-item nzTitle="File Name" [nzSpan]="2">
                {{ currentJob?.FileName }}
            </nz-descriptions-item>
        }
        <nz-descriptions-item nzTitle="Job ID">
            {{ currentJob?.JobID }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Status">
            {{ currentJob?.JobStatus }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Job Type">
            {{ currentJob?.JobType === 4 ? "Process to PerForma" : "Load from Scanner" }}
        </nz-descriptions-item>
        @if (currentJob?.JobCreateTime) {
            <nz-descriptions-item nzTitle="Create Time">
                {{ $safeNavigationMigration(currentJob?.JobCreateTime) | date: "M/d/yy h:mm a" }}
            </nz-descriptions-item>
        }
        @if (currentJob?.JobStartTime) {
            <nz-descriptions-item nzTitle="Start Time">
                {{ $safeNavigationMigration(currentJob?.JobStartTime) | date: "M/d/yy h:mm a" }}
            </nz-descriptions-item>
        }
        @if (currentJob?.JobEndTime) {
            <nz-descriptions-item nzTitle="End Time">
                {{ $safeNavigationMigration(currentJob?.JobEndTime) | date: "M/d/yy h:mm a" }}
            </nz-descriptions-item>
        }
    </nz-descriptions>

    @if (currentJob?.JobType !== 4) {
        <nz-descriptions nzBordered nzSize="small" [nzColumn]="2" nzTitle="Scan Parameters" style="margin-top: 16px">
            @if ($any($safeNavigationMigration(currentJob?.JobParams))?.ScanDirectoryId) {
                <nz-descriptions-item nzTitle="Scan Directory">
                    <a
                        [routerLink]="'/configure/scandirectoryedit'"
                        [queryParams]="{
                            id: $safeNavigationMigration(
                                $any($safeNavigationMigration(currentJob?.JobParams))?.ScanDirectoryId
                            )
                        }"
                        (click)="closeModal()">
                        {{
                            directoryMap[$any($safeNavigationMigration(currentJob?.JobParams))?.ScanDirectoryId] ||
                                $any($safeNavigationMigration(currentJob?.JobParams))?.ScanDirectoryId
                        }}
                    </a>
                </nz-descriptions-item>
            }
            @if ($any($safeNavigationMigration(currentJob?.JobParams))?.Pages) {
                <nz-descriptions-item nzTitle="Pages">
                    {{ $any($safeNavigationMigration(currentJob?.JobParams))?.Pages }}
                </nz-descriptions-item>
            }
            @if (
                $any($safeNavigationMigration(currentJob?.JobParams))?.AiPromptTokens ||
                $any($safeNavigationMigration(currentJob?.JobParams))?.AiCandidateTokens
            ) {
                <nz-descriptions-item nzTitle="AI Tokens" [nzSpan]="2">
                    {{
                        ($any($safeNavigationMigration(currentJob?.JobParams))?.AiPromptTokens ?? 0) +
                            ($any($safeNavigationMigration(currentJob?.JobParams))?.AiCandidateTokens ?? 0)
                    }}
                    (Prompt: {{ $any($safeNavigationMigration(currentJob?.JobParams))?.AiPromptTokens ?? 0 }}, Response:
                    {{ $any($safeNavigationMigration(currentJob?.JobParams))?.AiCandidateTokens ?? 0 }})
                </nz-descriptions-item>
            }
        </nz-descriptions>
    }

    @if (currentJob?.JobType === 4) {
        <nz-descriptions nzBordered nzSize="small" [nzColumn]="2" nzTitle="Process Parameters" style="margin-top: 16px">
            @if ($any($safeNavigationMigration(currentJob?.JobParams))?.ScanID) {
                <nz-descriptions-item nzTitle="Scan ID">
                    {{ $any($safeNavigationMigration(currentJob?.JobParams))?.ScanID }}
                </nz-descriptions-item>
            }
            @if ($any($safeNavigationMigration(currentJob?.JobParams))?.OriginJobID) {
                <nz-descriptions-item nzTitle="Origin Job ID">
                    {{ $any($safeNavigationMigration(currentJob?.JobParams))?.OriginJobID }}
                </nz-descriptions-item>
            }
        </nz-descriptions>
    }
</ng-template>
